import { render, staticRenderFns } from "./DropDownMenu.vue?vue&type=template&id=34cc9bb0"
import script from "./DropDownMenu.vue?vue&type=script&lang=js"
export * from "./DropDownMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconEllipsisV: require('/opt/atlassian/pipelines/agent/build/components/icon/IconEllipsisV.vue').default})
